import {APP_INITIALIZER, Injector, LOCALE_ID, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {TranslateCompiler, TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {LOCATION_INITIALIZED, registerLocaleData} from '@angular/common';
import {ConfigService} from './application/config/config.service';
import {CookieInterceptorService} from './application/security/cookie-interceptor.service';
import {AccountIdInterceptorService} from './application/security/account-id-interceptor.service';
import {LogoutComponent} from './interfaces/pages/logout/logout.component';
import {LoginComponent} from './interfaces/pages/login/login.component';
import {SharedModule} from './shared.module';
import localeFr from '@angular/common/locales/fr';
import {HomeComponent} from './interfaces/pages/home/home.component';
import {HomeDashboardComponent} from './interfaces/pages/home/dashboard/home-dashboard.component';
import {HomeMenuComponent} from './interfaces/pages/home/menu/home-menu.component';
import {HomeMenuSwitchAccountComponent} from './interfaces/pages/home/menu/switch-account/home-menu-switch-account.component';
import {
  HomeAssistanceCreateRequestDialogComponent
} from './interfaces/pages/home/assistance/create-request-dialog/home-assistance-create-request-dialog.component';
import {HomeAssistanceListDialogComponent} from './interfaces/pages/home/assistance/list-dialog/home-assistance-list-dialog.component';
import {
  HomeAssistanceDeleteDialogComponent
} from './interfaces/pages/home/assistance/delete-dialog/home-assistance-delete-dialog.component';
import {
  HomeAssistanceDuplicateDialogComponent
} from './interfaces/pages/home/assistance/duplicate-dialog/home-assistance-duplicate-dialog.component';
import {HomeAssistanceEditDialogComponent} from './interfaces/pages/home/assistance/edit-dialog/home-assistance-edit-dialog.component';
import {
  HomeAssistanceListFilterComponent
} from './interfaces/pages/home/assistance/list-dialog/filter/home-assistance-list-filter.component';
import {
  HomeAssistanceListFilterFormComponent
} from './interfaces/pages/home/assistance/list-dialog/filter/form/home-assistance-list-filter-form.component';
import {HomeDashboardWidgetComponent} from './interfaces/pages/home/dashboard/widget/home-dashboard-widget.component';
import {
  HomeDashboardWidgetBankproposalLargeComponent
} from './interfaces/pages/home/dashboard/widget/bankproposal/large/home-dashboard-widget-bankproposal-large.component';
import {
  HomeDashboardWidgetBankproposalSmallComponent
} from './interfaces/pages/home/dashboard/widget/bankproposal/small/home-dashboard-widget-bankproposal-small.component';
import {
  HomeDashboardWidgetDebtSummaryComponent
} from './interfaces/pages/home/dashboard/widget/debt-summary/home-dashboard-widget-debt-summary.component';
import {
  HomeDashboardWidgetFundingtenderComponent
} from './interfaces/pages/home/dashboard/widget/fundingtender/home-dashboard-widget-fundingtender.component';
import {
  HomeDashboardWidgetCatalogDialogComponent
} from './interfaces/pages/home/dashboard/available-widgets/home-dashboard-widget-catalog-dialog.component';
import {HomeNewsAgendaComponent} from './interfaces/pages/home/agenda/home-news-agenda.component';
import {HomeNewsAgendaEventComponent} from './interfaces/pages/home/agenda/event/home-news-agenda-event.component';
import {CreateEventDialogComponent} from './interfaces/pages/home/agenda/dialog-create/create-event-dialog.component';
import {TranslateMessageFormatCompiler} from 'ngx-translate-messageformat-compiler';
import {CustomTranslateLoader} from './custom-translate-loader';
import {
  HomeDashboardWidgetInviseoVariablesComponent
} from './interfaces/pages/home/dashboard/widget/inviseo/inviseo-variables/home-dashboard-widget-inviseo-variables.component';
import {
  HomeDashboardWidgetDebtMonthlyPaymentsComponent
} from './interfaces/pages/home/dashboard/widget/debt-monthly-payments/home-dashboard-widget-debt-monthly-payments.component';
import {DeleteEventDialogComponent} from './interfaces/pages/home/agenda/dialog-create/delete-event-dialog/delete-event-dialog.component';
import {
  HomeDashboardWidgetSimulationSmallComponent
} from './interfaces/pages/home/dashboard/widget/simulation/small/home-dashboard-widget-simulation-small.component';
import {
  HomeDashboardWidgetSimulationLargeComponent
} from './interfaces/pages/home/dashboard/widget/simulation/large/home-dashboard-widget-simulation-large.component';
import {
  HomeDashboardWidgetGuarantyComponent
} from './interfaces/pages/home/dashboard/widget/guaranty/home-dashboard-widget-guaranty.component';
import {
  CreateOrModifyAdvertisingDialogComponent
} from './interfaces/pages/home/advertising/dialog/create-or-modify/create-or-modify-advertising-dialog.component';
import {AdvertisingDialogComponent} from './interfaces/pages/home/advertising/advertising-dialog.component';
import {ListAdvertisingDialogComponent} from './interfaces/pages/home/advertising/dialog/list/list-advertising-dialog.component';
import {
  DeleteAdvertisingDialogComponent
} from './interfaces/pages/home/advertising/dialog/delete-advertising-dialog/delete-advertising-dialog.component';
import {
  HomeDashboardWidgetMessageComponent
} from './interfaces/pages/home/dashboard/widget/message/home-dashboard-widget-message.component';
import {
  HomeDashboardWidgetFundingTenderSpecificationsComponent
} from './interfaces/pages/home/dashboard/widget/fundingtender/specifications/home-dashboard-widget-funding-tender-specifications.component';
import {
  HomeDashboardWidgetFundingTenderPublishedComponent
} from './interfaces/pages/home/dashboard/widget/fundingtender/published/home-dashboard-widget-funding-tender-published.component';
import {
  HomeDashboardWidgetFundingTenderOngoingAnalysisComponent
} from './interfaces/pages/home/dashboard/widget/fundingtender/ongoing-analysis/home-dashboard-widget-funding-tender-ongoing-analysis.component';
import {
  HomeDashboardWidgetInviseoScenariosPartagesComponent
} from './interfaces/pages/home/dashboard/widget/inviseo/scenarios-partages/home-dashboard-widget-inviseo-scenarios-partages.component';
import {
  HomeDashboardWidgetPublicationLatestArticlesComponent
} from './interfaces/pages/home/dashboard/widget/publication/latest-articles/home-dashboard-widget-publication-latest-articles.component';
import {
  HomeDashboardWidgetPublicationLatestVideosXlargeComponent
} from './interfaces/pages/home/dashboard/widget/publication/latest-videos/xlarge/home-dashboard-widget-publication-latest-videos-xlarge.component';
import {
  HomeDashboardWidgetPublicationArticleItemComponent
} from './interfaces/pages/home/dashboard/widget/publication/item/home-dashboard-widget-publication-article-item.component';
import {
  HomeDashboardWidgetConsultantLargeComponent
} from './interfaces/pages/home/dashboard/widget/consultant/large/home-dashboard-widget-consultant-large.component';
import {
  HomeDashboardWidgetPublicationLatestVideosLargeComponent
} from './interfaces/pages/home/dashboard/widget/publication/latest-videos/large/home-dashboard-widget-publication-latest-videos-large.component';
import {
  HomeDashboardWidgetPublicationLatestVideosXlargeItemComponent
} from './interfaces/pages/home/dashboard/widget/publication/latest-videos/xlarge/item/home-dashboard-widget-publication-latest-videos-xlarge-item.component';
import {
  HomeDashboardWidgetEventLatestEventsXlargeComponent
} from './interfaces/pages/home/dashboard/widget/event/latest-events/xlarge/home-dashboard-widget-event-latest-events-xlarge.component';
import {
  HomeDashboardWidgetEventItemComponent
} from './interfaces/pages/home/dashboard/widget/event/item/home-dashboard-widget-event-item.component';
import {DialogEventsComponent} from './interfaces/pages/home/agenda/dialog-events/dialog-events.component';
import {CookieService} from 'ngx-cookie-service';

const configInitializerFn = (configService: ConfigService) => () => configService.loadConfig();

const translateInitializerFactory = (translate: TranslateService, injector: Injector) => {
  return () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      const langToSet = translate.getBrowserLang();
      translate.use(langToSet).subscribe(() => {
        // Successfully initialized
      }, () => {
        console.error(`Problem with '${langToSet}' language initialization.'`);
      }, () => {
        resolve(null);
      });
    });
  });
};

/** Custom Factory **/
const HttpLoaderFactory = (http: HttpClient): CustomTranslateLoader => {
  return new CustomTranslateLoader(http);
};

registerLocaleData(localeFr, 'fr');

@NgModule({
            declarations: [
                AppComponent,
                LoginComponent,
                LogoutComponent,
                HomeComponent,
                HomeDashboardComponent,
                HomeMenuComponent,
                HomeMenuSwitchAccountComponent,
                HomeAssistanceCreateRequestDialogComponent,
                HomeAssistanceListDialogComponent,
                HomeAssistanceDeleteDialogComponent,
                HomeAssistanceDuplicateDialogComponent,
                HomeAssistanceEditDialogComponent,
                HomeAssistanceListFilterComponent,
                HomeAssistanceListFilterFormComponent,
                HomeDashboardWidgetComponent,
                HomeDashboardWidgetBankproposalLargeComponent,
                HomeDashboardWidgetBankproposalSmallComponent,
                HomeDashboardWidgetDebtSummaryComponent,
                HomeDashboardWidgetSimulationSmallComponent,
                HomeDashboardWidgetSimulationLargeComponent,
                HomeDashboardWidgetMessageComponent,
                HomeDashboardWidgetFundingtenderComponent,
                HomeDashboardWidgetInviseoVariablesComponent,
                HomeDashboardWidgetCatalogDialogComponent,
                HomeNewsAgendaComponent,
                HomeNewsAgendaEventComponent,
                CreateEventDialogComponent,
                ListAdvertisingDialogComponent,
                AdvertisingDialogComponent,
                CreateOrModifyAdvertisingDialogComponent,
                DeleteAdvertisingDialogComponent,
                DeleteEventDialogComponent,
                HomeDashboardWidgetDebtMonthlyPaymentsComponent,
                HomeDashboardWidgetGuarantyComponent,
                HomeDashboardWidgetFundingTenderSpecificationsComponent,
                HomeDashboardWidgetFundingTenderPublishedComponent,
                HomeDashboardWidgetFundingTenderOngoingAnalysisComponent,
                HomeDashboardWidgetInviseoScenariosPartagesComponent,
                HomeDashboardWidgetPublicationLatestVideosXlargeComponent,
                HomeDashboardWidgetPublicationLatestVideosXlargeItemComponent,
                HomeDashboardWidgetPublicationLatestVideosLargeComponent,
                HomeDashboardWidgetPublicationLatestArticlesComponent,
                HomeDashboardWidgetPublicationArticleItemComponent,
                HomeDashboardWidgetConsultantLargeComponent,
                HomeDashboardWidgetEventLatestEventsXlargeComponent,
                HomeDashboardWidgetEventItemComponent,
                DialogEventsComponent
            ],
            imports: [
              SharedModule,
              TranslateModule.forRoot({
                                        loader: {
                                          provide: TranslateLoader,
                                          useFactory: HttpLoaderFactory,
                                          deps: [HttpClient]
                                        },
                                        compiler: {
                                          provide: TranslateCompiler,
                                          useClass: TranslateMessageFormatCompiler
                                        }
                                      })
            ],
            providers: [
              {
                provide: HTTP_INTERCEPTORS,
                useClass: CookieInterceptorService,
                multi: true
              },
              {
                provide: HTTP_INTERCEPTORS,
                useClass: AccountIdInterceptorService,
                multi: true
              },
              {
                provide: APP_INITIALIZER,
                useFactory: configInitializerFn,
                multi: true,
                deps: [ConfigService]
              },
              {
                provide: LOCALE_ID,
                useValue: 'fr-FR'
              },
              {
                provide: APP_INITIALIZER,
                useFactory: translateInitializerFactory,
                deps: [TranslateService, Injector],
                multi: true
              },
              CookieService
            ],
            bootstrap: [AppComponent]
          })
export class AppModule {
}
